import Tone from 'tone';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import {AudioParamPercentageValueParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';

var edgeCount = 0;
var disposedEdgeCount = 0;
class ModEdge {
    constructor(operator, sequencerEngine, outputNumber=0, name) {
        this.name = name;
        this.sequencerEngine = sequencerEngine;
        this.store = sequencerEngine.store;
        this.operator = operator;
        this.outputNumber = outputNumber;
        this.effect = operator;

        this.modulatorNodes= [];
        for (let i=0; i < operator.voices.length; i++) {
            this.modulatorNodes.push(new Tone.Gain(0));
        }

        this.loadSynth(operator);

        this.parameters = [];
        this.gainParameter = new AbstractAudioParamParameter(
            'Gain', this,
            (o, x) => this.modulatorNodes.forEach(m => m.gain.value = x),
            {
                min: 0,
                max: 6,
                defaultValue: 0,
            });
        this.registerParameter(this.gainParameter);
        this.gainParameter.setAudioParams(
            this.modulatorNodes.map(x => x.gain));
    }

    loadSynth(disconnect=false) {
        let operator = this.operator;
        if (operator.synth) {
            // This edge's destination is another operator (oscillator)
            for (let i in this.operator.voices) {
                let voice = operator.voices[i];
                if (disconnect) {
                    this.modulatorNodes[i].disconnect();
                }
                // connect the modulator nodes here to the destination operator's
                // frequency. So when the source operator uses this edge,
                // there will be connection between the source and the destination's
                // frequencies
                this.modulatorNodes[i].connect(voice.oscillator.frequency);
            }
        } else {
            // the edge destination is the synth output (either X or Y)
            let output = operator;
            /*
            for (let i in output.voices) {
                // simply connect each voice to the output
                let voice = output.voices[i];
                this.out[i].connect(output.voices[i]);
            }
            */
        }
    }

    registerParameter(parameter) {
        if (parameter !== undefined) {
            parameter.name = parameter.name;
            parameter.effectName = this.name;
            parameter.setStore(this.store);
            this.parameters.push(parameter);
        }
    }

    getWeight() {
        return 1;
    }

    getJson() {
        return {};
    }

    fromJson() {
    }

    getCopy() {
        let edge = new ModEdge(this.operator, this.sequencerEngine, this.outputNumber);
        edge.gainParameter.set(edge.gainParameter.get());
        return edge;
    }

    dispose() {
        this.gainParameter.dispose();
        this.modulatorNodes.forEach(n => n.dispose());
        this.gainParameter = undefined;
        this.modulatorNodes = undefined;
    }
}

export default ModEdge;
